import * as React from 'react';
import {useNavigate} from 'react-router-dom';
import {makeStyles} from '@mui/styles';
import {Avatar, Box, Divider, ToggleButton, Typography} from '@mui/material';
import SubjectIcon from '@mui/icons-material/Subject';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

const useStyles = makeStyles({
  menuImage: {
    position: 'fixed',
    left: 65,
    top: 0,
    width: 235,
    height: 129,
    backgroundSize: 'cover',
    backgroundColor: 'white',
    borderRight: '1px solid #CCC',
    borderBottom: '1px solid #DDD'
  },
  menuTitle: {
    color: 'white',
    textStroke: '1px #CCC',
    padding: 20,
    fontSize: 19,
    lineHeight: '25px',
    fontFamily: "Helvetica"
  },
  menuTopTitle: {
    fontWeight: 700,
    fontSize: 16,
    paddingLeft: 15
  },
  menuToggle: {
    border: 0,
    backgroundColor: 'none',
    position: 'absolute',
    bottom: 25,
  },
  menuToggleActive: {
    marginLeft: 15
  },
  menuDashboardLink: {
    display: 'block',
    paddingBottom: 15,
    paddingLeft: 15,
  },
  menuSubWrapper: {
    width: '300px',
    backgroundColor: 'white',
    height: '100vh',
    marginLeft: '-15px',
    padding: '20px',
    marginTop: '-100px',
    paddingTop: '100px',
    overflowY: 'auto',
    overFlowX: 'hidden',
    borderLeft: '1px solid #CCC',
    borderRight: '1px solid #CCC'
  },
  sidebarTop: {
    cursor: 'pointer',
    height: 120
  },
});

const SidebarMenu = ({data}) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const menuData = JSON.parse(data.page_index);
  const book_links = menuData.book_links;
  const [selected, setSelected] = React.useState(false);
  const [menuWidth, setMenuWidth] = React.useState(66);
  let active = false;
  let item: JSX.Element = '';

  const handleMenuClick = (e, path) => {
    e.stopPropagation();
    navigate(path);
  }

  const handleMenuToggle = () => {
    setSelected(!selected);
    if (!selected)
      setMenuWidth(300);
    else
      setMenuWidth(66);
  }

  const generateNumberMenu = () => {
    const numbered_menu = [];

    for (const key in book_links) {
      if (Object.hasOwn(book_links, key)) {
        active = book_links[key].active === true;

        item = (
          <li
            key={book_links[key].nid}
            className={`list-group-item-numbered ${book_links[key].theme} py-2 ${active ? 'active' : ''}`}
            onClick={() => handleMenuToggle()}
          />
        )
        numbered_menu.push(item);
      }
    }

    return numbered_menu;
  }

  const generateMenu = () => {
    const rows = [];
    const depth = 1;
    let children = [];
    let has_children = false;

    for (const key in book_links) {
      if (Object.hasOwn(book_links, key)) {
        children = [];
        has_children = false;
        active = false;
        if (Object.keys(book_links[key].children).length > 0) {
          children.push(generateSubMenu(book_links[key].children, book_links[key].nid, depth, book_links[key].title));
          has_children = true;
        }
        if (book_links[key].active === true) {
          active = true;
        }

        item = (
          <li
            className={`list-group-item ${book_links[key].theme} py-2 ${active ? 'active' : ''} ${has_children ? 'has_children' : ''}`}
            key={book_links[key].nid} onClick={() => handleMenuToggle()}>
            <a href={book_links[key].url}>
              <span className="ml-2">{book_links[key].title}</span>
            </a>
            {children}
          </li>
        );
        rows.push(item);
      }
    }

    return rows;
  }

  const generateSubMenu = (data, parentNid, depth, menu_title) => {
    const rows = [];
    let submenu = [];
    let active = false;
    let has_children = false;

    for (const childKey in data) {
      if (Object.hasOwn(data, childKey)) {
        submenu = [];
        active = false;
        has_children = false;
        if (Object.keys(data[childKey].children).length > 0) {
          submenu.push(generateSubMenu(data[childKey].children, data[childKey].nid, depth + 1, data[childKey].title));
          has_children = true;
        }
        if (data[childKey].active === true) {
          active = true;
        }

        const color_theme = data[childKey].theme;

        item = (
          <li
            className={`list-group-item-sub ${color_theme} py-2 ${active ? 'active' : ''} ${has_children ? 'has_children' : ''}`}
            key={data[childKey].nid} onClick={(e) => handleMenuClick(e, data[childKey].url)}>
            <a href={data[childKey].url}>{data[childKey].title}</a>
            {submenu}
          </li>
        );
        rows.push(item);
      }
    }

    return (
      <ul className="list-group flex-column d-inline-block submenu"
          style={{left: 299 * depth + 'px', zIndex: 999 + depth}} key={`submenu-${parentNid}`}>
        <div className={classes.menuSubWrapper}>
          <Typography className={classes.menuTopTitle}>{menu_title}</Typography>
          {rows}
        </div>
      </ul>
    );
  }

  const main_menu = generateMenu();
  const number_menu = generateNumberMenu();

  return (
    <>
      <div className="sidebar">
        <div className={classes.sidebarTop}>
          <Box sx={{margin: '8px'}}>
            <Avatar alt={menuData.book_info.title} src={menuData.book_info.img_url} sx={{width: 50, height: 50}}
                    onClick={() => handleMenuToggle()}/>
          </Box>
          <Box sx={{margin: '18px'}}>
            <SubjectIcon sx={{fontSize: 30}} onClick={() => handleMenuToggle()}/>
          </Box>
        </div>

        {selected ? <div className={classes.menuImage} style={{backgroundImage: `url(${menuData.book_info.img_url})`}}>
          <Typography className={classes.menuTitle}>{menuData.book_info.title}</Typography>
        </div> : ''}

        <Divider/>

        <div className="sidebar-menu">
          <ol className="list-group flex-column d-inline-block first-menu" style={{width: menuWidth}} key="first-menu">
            {selected ? main_menu : number_menu}
          </ol>
        </div>

        <div className="sidebar-toggle" style={{width: menuWidth}}>
          {selected ? <a className={classes.menuDashboardLink} href="/user">Terug naar dashboard</a> : ''}

          <ToggleButton
            value="check"
            selected={selected}
            className={classes.menuToggle + ` ${selected ? classes.menuToggleActive : ""}`}
            onChange={() => {
              handleMenuToggle()
            }}
            size="small"
          >
            {selected ? <><ArrowBackIosIcon/>INKLAPPEN</> : <ArrowForwardIosIcon/>}
          </ToggleButton>
        </div>

      </div>
    </>
  );
}

export default SidebarMenu;
